import { ValidateIf } from 'class-validator';
export function IsUndefinableIf(condition, validationOptions) {
    return ValidateIf((object, value) => {
        return !condition(object, value) ? true : undefined !== value;
    }, validationOptions);
}
//# sourceMappingURL=IsUndefinableIf.js.map